import styled from 'styled-components'
import * as BaseStyles from '../BaseStyles'

export const ComponentsDiv = styled(BaseStyles.ComponentsDiv)`
    top: 0rem;
    bottom: 0rem;
    left: 0rem;
    right: 0rem;
    overflow: auto;
`